import { Grid, Typography } from '@mui/material';
import type { CodingColumnId } from 'app/util/columnVisibility';

interface CodingSidesheetGridProps {
  visibleColumnIds: CodingColumnId[];
  getLabel: (colId: CodingColumnId) => string;
  renderContent: (colId: CodingColumnId) => React.ReactNode;
}

/**
 * Shared layout for all coding-system sidesheet forms.
 * Iterates visible column IDs, renders a label + dropdown for each one
 * that has content. The per-module rendering logic is provided via renderContent.
 */
export function CodingSidesheetGrid({ visibleColumnIds, getLabel, renderContent }: CodingSidesheetGridProps) {
  return (
    <Grid container spacing={2}>
      {visibleColumnIds.map((colId) => {
        const content = renderContent(colId);
        if (!content) return null;
        return (
          <Grid item xs={12} key={colId}>
            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
              {getLabel(colId)}
            </Typography>
            {content}
          </Grid>
        );
      })}
    </Grid>
  );
}
